module.exports = __webpack_public_path__ + "img/744.2b9a0316.jpg";